export default __webpack_public_path__ + "static/media/MohanLalJi.5e028902.jpeg";